import { PropsWithChildren } from 'react'
import { captureException } from '@sentry/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { isAxiosError } from 'axios'

import { useToasts } from '../modules/toasts/ToastsProvider'

export const ReactQueryProvider = ({ children }: PropsWithChildren) => {
  const { addToast } = useToasts()

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        retry: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retryDelay: 1000,
        retryOnMount: false,
      },
      mutations: {
        onError: error => {
          if (isAxiosError(error) && error.response?.data.message) {
            addToast({
              label: error.response.data.message,
              icon: { name: 'Cross', size: 24, color: 'red' },
            })
          } else {
            captureException(error)
          }
        },
      },
    },
  })

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
